// 导入核心库
import Vue from 'vue';
import router from './router';
import store from './store/index.js';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import ElementUI from 'element-ui';
import axios from 'axios';
import moment from 'moment';
import App from './App';
import * as echarts from 'echarts';
//import htmlToPdf from '@/utils/htmlToPdf'



// 导入组件样式和全局样式
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/comm.scss';

// 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueCookies);
//Vue.use(htmlToPdf)//页面导出pdf
// 汉化
moment.locale();
// 把 moment 挂载到 Vue 原型上，方便组件内使用
Vue.prototype.$moment = moment;
// 把 axios 挂载到 Vue 原型上，方便组件内使用
Vue.prototype.$axios = axios;

Vue.prototype.$echarts = echarts


// 把 baseUrl 挂载到 Vue 原型上，方便组件内使用
const baseUrl = process.env.API_ROOT;
window.baseUrl = baseUrl;
Vue.prototype.baseUrl = baseUrl;

// 全局事件总线
let bus = new Vue();
window.eventBus = bus;
Vue.prototype.bus = bus;


// 为了实现Class的私有属性
const showMessage = Symbol('showMessage')
/**
 *  重写ElementUI的Message
 *  single默认值true，因为项目需求，默认只弹出一个，可以根据实际需要设置
 */

import {
  Message
} from 'element-ui'

class DonMessage {
  success(options, single = true) {
    this[showMessage]('success', options, single)
  }
  warning(options, single = true) {
    this[showMessage]('warning', options, single)
  }
  info(options, single = true) {
    this[showMessage]('info', options, single)
  }
  error(options, single = true) {
    this[showMessage]('error', options, single)
  }

  [showMessage](type, options, single) {
    if (single) {
      // 判断是否已存在Message
      if (document.getElementsByClassName('el-message').length === 0) {
        Message[type](options)
      }
    } else {
      Message[type](options)
    }
  }
}

// ...

Vue.use(ElementUI)
// 命名根据需要，DonMessage只是在文章中使用
Vue.prototype.$message = new DonMessage()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js